import type { PortfolioTestimonialItem } from '../../firebase/types/portfolio.types';
import { Band, SectionIndex } from './ui';

export default function TestimonialsSection({
  testimonials,
  index,
}: {
  testimonials: PortfolioTestimonialItem[];
  index: string;
}) {
  return (
    <Band id="testimonials">
      <SectionIndex index={index} title="Testimonials" />
      <div className="space-y-8">
        {testimonials.map((item, i) => (
          <figure key={i} className={i === 0 ? '' : 'border-t border-line pt-8'}>
            {item.feedback ? (
              <blockquote
                className={
                  i === 0
                    ? 'max-w-4xl text-[clamp(1.55rem,3vw,2.7rem)] font-medium leading-[1.2] text-ink'
                    : 'max-w-3xl text-xl leading-snug text-ink md:text-2xl'
                }
              >
                {item.feedback}
              </blockquote>
            ) : null}
            <figcaption className="mt-6 text-sm text-faint">
              {item.clientName || 'Client'}
              {item.projectType ? ` — ${item.projectType}` : ''}
            </figcaption>
          </figure>
        ))}
      </div>
    </Band>
  );
}
